<template>
  <div id="departmentSelector">
    <div class="selector-box">
      <div class="left-box">
        <p
          v-for="(item, index) in list"
          :class="{'active' : selectorObj.orgSelector.id == item.id}"
          @click="selectorOrg(item, index)"
          :key="index"
        >{{ item.typeName }}</p>
      </div>
      <div class="right-box" v-if="list[activeIdx].list && list[activeIdx].list.length>0">
        <p
          v-for="(item,index) in list[activeIdx].list"
          :class="{'active': selectorObj.departmentSelector && selectorObj.departmentSelector.ORGID == item.ORGID }"
          @click="selectorDepartment(item)"
          :key="index"
        >{{ item.ORGNAME }}</p>
      </div>
      <div class="select-btn">
        <van-button
          type="primary"
          block
          color="var(--main-color)"
          @click="fixDepartment">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";

export default {
  name: "DepartmentSelector",
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectorObj: {
      type: Object,
      default: () => {
        return {
          orgSelector: {},
          departmentSelector: {}
        }
      }
    }
  },
  data() {
    return {
      activeIdx: 0,
      deptSelect: true,
    }
  },
  created() {
   this.init()
  },
  methods: {
    init() {
      this.org = this.selectorOrg.orgSelector;
      this.dept = this.selectorOrg.departmentSelector;
      let orgId = this.selectorObj.orgSelector.id;
      this.list.forEach((item, index) => {
        if (item.id == orgId) {
          this.activeIdx = index;
          return
        }
      })
    },
    // 机构点击事件
    selectorOrg(e, index) {
      this.activeIdx = index;
      this.selectorDepartment(null);
      this.$emit('selectedOrg', e)
      if (this.list[index].list.indexOf(this.selectorObj.departmentSelector) != -1) {
        this.deptSelect = true;
      } else {
        this.deptSelect = false;
      }
    },
    // 部门点击事件
    selectorDepartment(e) {
      if (e) {
        this.deptSelect = true;
      } else {
        this.deptSelect = false;
      }
      this.$emit('selectedDepartment', e)
    },
    // 确定点击事件
    fixDepartment() {
      if (this.deptSelect) {
        this.$emit('fixedSelector')
      } else {
        Toast.fail('请选择部门');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
.selector-box{
  display: flex;
  width: 100%;
  height: 215px;
  background: #fff;
  padding-bottom: 60px;
  position: absolute;
  top: 49px;
  left: 0;
  .left-box{
    width: 88px;
    height: 215px;
    background: #f7f7f7;
    overflow-x: hidden;
    overflow-y: auto;
    flex-shrink: 0;
    @extend .color333;
    @extend .font13;
    p{
      height: 56px;
      line-height: 56px;
      padding: 0 10px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.active{
       background: var(--main-color);
       color: #fff;
      }
    }
  }
  .right-box{
    height: 215px;
    padding: 13px 20px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
    @extend .color333;
    @extend .font14;
    p{
      height: 35px;
      line-height: 35px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.active{
         color: var(--main-color);
      }
    }
  }
  .select-btn{
    height: 40px;
    padding: 10px 15px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    .van-button{
      height: 40px;
      border-radius: 5px;
    }
  }
}
</style>